import React from 'react';
import { useNavigate } from '@thd-olt-component-react/router';
import { ProductDetails } from '@thd-olt-component-react/product-details'
import PropTypes from 'prop-types';
import {
  extend,
  params,
  shape as shapeType,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';

const ProductDetailsQuestionsRatings = ({ itemId, page }) => {
  const navigate = useNavigate();
  const { data, error, loading } = useDataModel('product',
    {
      variables: {
        itemId
      }
    }
  );

  if ((loading && !(data || data?.product?.identifiers)) || error) {
    return null;
  }
  const { canonicalUrl } = data?.product?.identifiers || {};

  const onProductRatingsClick = (target) => {
    navigate(target);
  }

  const pageNumber = page === undefined ? '1' : page;
  const reviewsLink = (canonicalUrl) && canonicalUrl?.replace('/p/', '/p/reviews/');
  const targetProductRatings = (reviewsLink) && `${reviewsLink}/1`
  let questionTargetLink = (canonicalUrl) && canonicalUrl?.replace('/p/', '/p/questions/');
  questionTargetLink += (pageNumber === '1') ? '/1#hydrator-questions-answers' : '/1';

  return (
    <ProductDetails.Ratings
      showBadge
      onClick={onProductRatingsClick}
      target={targetProductRatings}
      targetURL={questionTargetLink || ''}
    />
  );
};

ProductDetailsQuestionsRatings.dataModel = extend(
  {
    product: params({
      itemId: stringType().isRequired()
    }).shape({
      itemId: stringType(),
      identifiers: shapeType({
        canonicalUrl: stringType()
      }),
    })
  },
  ProductDetails.Ratings
);

ProductDetailsQuestionsRatings.propTypes = {
  itemId: PropTypes.string.isRequired,
  page: PropTypes.string
};

ProductDetailsQuestionsRatings.defaultProps = {
  page: '1'
};

ProductDetailsQuestionsRatings.displayName = 'ProductDetailsQuestionsRatings';

export default ProductDetailsQuestionsRatings;